module.exports = __webpack_public_path__ + "img/03_sp.776d34e3.jpg";